import { createContext } from 'react';
import type { ApiResponse } from '../../../services/api';
import type { Project, ProjectFormValues, ProjectUpdateValues } from '../types';

export interface ProjectsContextValue {
  projects: Project[];
  isLoading: boolean;
  /** True once the first load finished; before that `enabled` is unknown. */
  isLoaded: boolean;
  enabled: boolean;
  limit: number | null;
  canCreate: boolean;
  refreshProjects: () => Promise<void>;
  createProject: (values: ProjectFormValues) => Promise<ApiResponse<Project>>;
  updateProject: (projectId: string, values: ProjectUpdateValues) => Promise<ApiResponse<Project>>;
  deleteProject: (projectId: string) => Promise<ApiResponse>;
}

export const ProjectsContext = createContext<ProjectsContextValue | null>(null);
